import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {FieldDefinition} from '@shared/models/field-definition';
import {Router} from '@angular/router';
import {CellComponent} from '@shared/components/cell-components/cell-component';

@Component({
    standalone: false,
    selector: 'particle-reporting-entity-dependant-string-cell-viewer',
  templateUrl: './reporting-entity-dependant-string-cell-viewer.component.html',
  styleUrls: ['./reporting-entity-dependant-string-cell-viewer.component.scss']
})
export class ReportingEntityDependantStringCellViewerComponent implements OnInit, CellComponent {

  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  icon: string;
  disabled: boolean;
  constructor(private router: Router) {
    this.disabled = false;
  }

  ngOnInit() {
    const ReportingEntity = 'ReportingEntity';
    const RelevantTaxpayerNexus = 'RelevantTaxpayerNexus';
    const RelevantTaxpayerCapacity = 'RelevantTaxpayerCapacity';
    const IntermediariesNexus = 'IntermediariesNexus';
    const IntermediariesCapacity = 'IntermediariesCapacity';
    const fieldDefinitionKey = this.fieldDefinition.key;


    if (this.item.cells[ReportingEntity] && this.item.cells[ReportingEntity].value) {
      const isIntermediary = this.item.cells[ReportingEntity].value.isIntermediary;
      if (isIntermediary && (fieldDefinitionKey === RelevantTaxpayerNexus || fieldDefinitionKey === RelevantTaxpayerCapacity)) {
        this.disabled = true;
      }

      if (!isIntermediary && (fieldDefinitionKey === IntermediariesNexus || fieldDefinitionKey === IntermediariesCapacity)) {
        this.disabled = true;
      }
    }
  }

  onClicked(action: string) {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
  }

}
